import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { ApiError } from '@/api/errors'
import { ErrorState, LoadingState, NotFoundState } from '@/components/feedback/States'
import { Breadcrumbs } from '@/components/ui/PageHeader'
import { reportCardQuery } from '@/features/exams/api'
import { ReportCardView } from '@/features/exams/components/ReportCardView'
import { useDocumentTitle } from '@/hooks/useDocumentTitle'

export function ExamReportCardPage() {
  const { t } = useTranslation('exams')
  const params = useParams()
  const examId = Number(params.id)
  const studentId = Number(params.studentId)
  const card = useQuery(reportCardQuery(examId, studentId))
  useDocumentTitle(card.data ? `${card.data.student.fullName} · ${card.data.exam.name}` : 'Report card')

  if (card.isPending) return <LoadingState />
  if (card.error) {
    return card.error instanceof ApiError && card.error.status === 404 ? (
      <NotFoundState resource="report card" homeHref={`/admin/exams/${examId}`} />
    ) : (
      <ErrorState onRetry={() => void card.refetch()} />
    )
  }
  return (
    <>
      <div className="print:hidden">
        <Breadcrumbs
          homeHref="/admin"
          items={[
            { label: t('Exams'), to: '/admin/exams' },
            { label: card.data.exam.name, to: `/admin/exams/${examId}?tab=results` },
            { label: card.data.student.fullName },
          ]}
        />
      </div>
      <div className="mt-3">
        <ReportCardView card={card.data} />
      </div>
    </>
  )
}
